import { createSlice } from '@reduxjs/toolkit';

const DEFAULT_SETUP_STATE = {
	activeTrack: 'spaces',
	activeStep: null,
	completedSteps: [],
	skippedSteps: [],
	inProgressSteps: [],
	seenWelcome: false,
	dismissedSurfaces: {
		overviewCta: null,
		homeBanner: null
	},
	hydrated: false
};

const onboardingSlice = createSlice({
	name: 'onboarding',
	initialState: {},
	reducers: {
		initSetup(state, action) {
			const { setupKey } = action.payload;
			if (!state[setupKey]) {
				state[setupKey] = {
					...DEFAULT_SETUP_STATE,
					dismissedSurfaces: { overviewCta: null, homeBanner: null }
				};
			}
		},
		hydrateSetup(state, action) {
			const { setupKey, savedState } = action.payload;
			if (!state[setupKey]) {
				state[setupKey] = {
					...DEFAULT_SETUP_STATE,
					dismissedSurfaces: { overviewCta: null, homeBanner: null }
				};
			}
			const { hydrated: _h, ...rest } = savedState;
			Object.assign(state[setupKey], rest, { hydrated: true });
		},
		setActiveTrack(state, action) {
			const { setupKey, trackId } = action.payload;
			if (state[setupKey]) state[setupKey].activeTrack = trackId;
		},
		setActiveStep(state, action) {
			const { setupKey, stepId } = action.payload;
			if (state[setupKey]) state[setupKey].activeStep = stepId;
		},
		completeStep(state, action) {
			const { setupKey, stepId } = action.payload;
			if (!state[setupKey]) return;
			const s = state[setupKey];
			if (!s.completedSteps.includes(stepId)) s.completedSteps.push(stepId);
			s.skippedSteps = s.skippedSteps.filter((id) => id !== stepId);
			s.inProgressSteps = s.inProgressSteps.filter((id) => id !== stepId);
		},
		skipStep(state, action) {
			const { setupKey, stepId } = action.payload;
			if (!state[setupKey]) return;
			const s = state[setupKey];
			if (!s.skippedSteps.includes(stepId)) s.skippedSteps.push(stepId);
			s.completedSteps = s.completedSteps.filter((id) => id !== stepId);
			s.inProgressSteps = s.inProgressSteps.filter((id) => id !== stepId);
		},
		markStepInProgress(state, action) {
			const { setupKey, stepId } = action.payload;
			if (!state[setupKey]) return;
			const s = state[setupKey];
			if (!s.inProgressSteps.includes(stepId)) s.inProgressSteps.push(stepId);
		},
		setSeenWelcome(state, action) {
			const { setupKey } = action.payload;
			if (state[setupKey]) state[setupKey].seenWelcome = true;
		},
		dismissSetupSurface(state, action) {
			const { setupKey, surface } = action.payload;
			if (state[setupKey]?.dismissedSurfaces) {
				state[setupKey].dismissedSurfaces[surface] = new Date().toISOString();
			}
		}
	},
	extraReducers: (builder) => {
		builder.addMatcher(
			(action) => action.type === 'auth/logout',
			() => ({})
		);
	}
});

export const onboardingActions = onboardingSlice.actions;
export default onboardingSlice.reducer;
